import { getAccessToken } from '../utils/session';
import {
    BASE_URL,
    CREATE_SECTION_MASTER_API,
    GET_SEARCH_SECTION_MASTER_API,
    GET_APPLICABLE_TO_LIST_API,
    GET_PAYEE_STATUS_LIST_API,
    DOWNLOAD_SECTION_MASTER_API,
    BULK_UPDATE_SECTION_API,
    GET_SECTION_AND_BROAD_API,
    RESET_SECTION_MASTER_API
} from '../endpoints/apiEndpoints';
import {
    buildRequestHeader,
    handleErrorResponse,
    handleRequestFailure,
    handleSuccessResponse,
    urlBuilder,
} from './apiUtils';

export const createSectionMasterApi= async (payload) => {
    try {
        const token = getAccessToken();
        const apiUrl = `${BASE_URL}/${CREATE_SECTION_MASTER_API}`;
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: token,
            },
            body: JSON.stringify(payload)
        };
        const response = await fetch(apiUrl, requestOptions);
        if (!response.ok) {
            let errorMessage;
            try {
                const errorData = await response.json();
                errorMessage =
                    errorData.message || `Request failed with status: ${response.status}`;
            } catch {
                errorMessage = `Request failed with status: ${response.status}`;
            }
            throw new Error(errorMessage);
        }
        const data = await response.json();
        if (data && data.success === false) {
            const errorMessage = data.message 
                || (Array.isArray(data.errors) && data.errors[0] && data.errors[0].message)
                || 'Request failed';
            return {
                success: false,
                error: errorMessage,
                data,
            };
        }
        return {
            success: true,
            data,
        };
    } catch (error) {
        console.error('Failed to Add New Section Master:');
        return {
            success: false,
            error: error.message || 'Failed to Add New Section Master',
        };
    }
};

export const searchSectionMasterApi= async (payload, tanUuid) => {
    try {
        const token = getAccessToken();
        const apiUrl = `${BASE_URL}/${GET_SEARCH_SECTION_MASTER_API}/${tanUuid}`;
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: token,
            },
            body: JSON.stringify(payload)
        };
        const response = await fetch(apiUrl, requestOptions);
        if (!response.ok) {
            let errorMessage;
            try {
                const errorData = await response.json();
                errorMessage =
                    errorData.message || `Request failed with status: ${response.status}`;
            } catch {
                errorMessage = `Request failed with status: ${response.status}`;
            }
            throw new Error(errorMessage);
        }
        const data = await response.json();
        if (data && data.success === false) {
            const errorMessage = data.message 
                || (Array.isArray(data.errors) && data.errors[0] && data.errors[0].message)
                || 'Request failed';
            return {
                success: false,
                error: errorMessage,
                data,
            };
        }
        return {
            success: true,
            data,
        };
    } catch (error) {
        console.error('Failed to Failed to Perform Search on Section Master:');
        return {
            success: false,
            error: error.message || 'Failed to Perform Search on Section Master',
        };
    }
};

export const applicableToListApi= async () => {
    try {
        const token = getAccessToken();
        const apiUrl = `${BASE_URL}/${GET_APPLICABLE_TO_LIST_API}`;
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: token,
            }
        };
        const response = await fetch(apiUrl, requestOptions);
        if (!response.ok) {
            let errorMessage;
            try {
                const errorData = await response.json();
                errorMessage =
                    errorData.message || `Request failed with status: ${response.status}`;
            } catch {
                errorMessage = `Request failed with status: ${response.status}`;
            }
            throw new Error(errorMessage);
        }
        const data = await response.json();
        if (data && data.success === false) {
            const errorMessage = data.message 
                || (Array.isArray(data.errors) && data.errors[0] && data.errors[0].message)
                || 'Request failed';
            return {
                success: false,
                error: errorMessage,
                data,
            };
        }
        return {
            success: true,
            data,
        };
    } catch (error) {
        console.error('Failed to create Rule Setting:');
        return {
            success: false,
            error: error.message || 'Failed to Fetch Applicable To List',
        };
    }
};

export const payeeStatusApi= async () => {
    try {
        const token = getAccessToken();
        const apiUrl = `${BASE_URL}/${GET_PAYEE_STATUS_LIST_API}`;
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: token,
            }
        };
        const response = await fetch(apiUrl, requestOptions);
        if (!response.ok) {
            let errorMessage;
            try {
                const errorData = await response.json();
                errorMessage =
                    errorData.message || `Request failed with status: ${response.status}`;
            } catch {
                errorMessage = `Request failed with status: ${response.status}`;
            }
            throw new Error(errorMessage);
        }
        const data = await response.json();
        if (data && data.success === false) {
            const errorMessage = data.message 
                || (Array.isArray(data.errors) && data.errors[0] && data.errors[0].message)
                || 'Request failed';
            return {
                success: false,
                error: errorMessage,
                data,
            };
        }
        return {
            success: true,
            data,
        };
    } catch (error) {
        console.error('Failed to Fetch Payee Status List:');
        return {
            success: false,
            error: error.message || 'Failed to Fetch Payee Status List',
        };
    }
};
export async function downloadSectionMasterExcel(payload, tanUuid) {
  const accessToken = getAccessToken()
  if (!accessToken) throw new Error('Missing access token in sessionStorage')

  const res = await fetch(`${BASE_URL}/${DOWNLOAD_SECTION_MASTER_API}/${tanUuid}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  })

  if (!res.ok) throw new Error(`Failed to download Section Master Excel: ${res.status}`)
  
  // Return as Blob (Excel file)
  const blob = await res.blob()
  return blob
}

export const updateSectionMasterApi = async (payload, sectionMasterUuid) => {
  const token = getAccessToken();
  const apiUrl = `${BASE_URL}/${CREATE_SECTION_MASTER_API}/${sectionMasterUuid}`;

  try {
    const res = await fetch(apiUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    // Clone the response to handle both JSON and text
    const clonedRes = res.clone();

    let responseBody;
    try {
      responseBody = await res.json();
    } catch {
      responseBody = await clonedRes.text();
    }

    if (!res.ok) {
      // Build a meaningful error message
      let errorMessage = "Failed to update SectionMaster";
      if (typeof responseBody === "string") {
        errorMessage = responseBody;
      } else if (responseBody?.broadHead && Object.keys(responseBody).length === 1) {
        errorMessage = responseBody.broadHead;
      } else if (responseBody?.message) {
        errorMessage = responseBody.message;
      } else if (responseBody?.error) {
        errorMessage = responseBody.error;
      }

      const error = new Error(errorMessage);
      error.status = res.status;
      error.body = responseBody;
      throw error;
    }

    return responseBody;
  } catch (error) {
    throw error;
  }
};



export const bulkUpdateSectionMasterApi = async payload => {
  const accessToken = getAccessToken();
  const apiUrl = `${BASE_URL}/${BULK_UPDATE_SECTION_API}`;

  const requestOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  };

  const res = await fetch(apiUrl, requestOptions);

  const clonedRes = res.clone();

  let responseBody;
  try {
    responseBody = await res.json();
  } catch {
    responseBody = await clonedRes.text();
  }

  if (!res.ok) {
    const errorMessage =
      (responseBody && responseBody.error) ||
      (responseBody && responseBody.message) ||
      (typeof responseBody === "string" ? responseBody : null) ||
      `Failed to perform bulk update: ${res.status}`;

    const error = new Error(errorMessage);
    error.status = res.status;
    error.body = responseBody;
    throw error;
  }

  return {
    success: true,
    data: responseBody,
  };
};


export const getSectionAndBroadDropdown = async() => {
  try {
    const token = getAccessToken()
    const apiUrl = `${BASE_URL}/${GET_SECTION_AND_BROAD_API}`
    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    }
    const response = await fetch(apiUrl, requestOptions)
    if (!response.ok) {
      let errorMessage
      try {
        const errorData = await response.json()
        errorMessage =
          errorData.message || `Request failed with status: ${response.status}`
      } catch {
        errorMessage = `Request failed with status: ${response.status}`
      }
      throw new Error(errorMessage)
    }
    const data = await response.json()
    return {
      success: true,
      data,
    }
  } catch (error) {
    console.error('Failed to Assign Entity to User:')
    return {
      success: false,
      error: error.message || 'Failed to Assign Entity to User',
    }
  }
}

export const resetSectionMasterApi = async tanUuid => {
  const url = urlBuilder(RESET_SECTION_MASTER_API, { tanUuid })
  const requestHeader = buildRequestHeader('POST', {})
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}